export default "__VITE_ASSET__BUxBOTu___"